<template>
  <v-container class="pa-4">
    <v-row>
      <v-col
        cols="6"
        md="6"
        sm="6"
      >
        <h2>配送製品一覧</h2>
      </v-col>
      <v-col
        cols="6"
        md="6"
        sm="6"
        class="text-right"
      >
        <v-btn
          :to="{ name: 'CreateDeliveryItem' }"
          class="title-btn red white--text"
        >
          新規登録
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="2"
      >
        <v-select
          label="カテゴリ"
          :items=$store.getters.deliveryItemCategories
          item-text="name"
          item-value="id"
          dense
          v-model="params.deliveryitemcategory"
          @change="getDeliveryItems"
        >
        </v-select>
      </v-col>
      <v-col
        cols="2"
      >
        <v-text-field
          label="製品名"
          dense
          v-model="params.name"
          @change="getDeliveryItems"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="items"
          :server-items-length="item_total"
          :loading="loading"
          :options.sync="options"
          :footer-props="footer_props"
          disable-sort
          disable-filtering
          locale="ja-jp"
          loading-text="読込中"
          no-data-text="データがありません。"
          @update:options="getDeliveryItems"
        >
        <template v-slot:item.action="{ item }">
          <v-btn
            small
            color="default"
            :to="{ name: 'EditDeliveryItem', params: {id: item.id}}"
          >
            詳細
          </v-btn>
          <v-menu
            bottom
            left
          >
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                class="ml-2"
                v-on="on"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list>
              <v-list-item
              dense
              @click="$router.push({ name: 'DeliveryItemDetail', params: {id: item.id}})"
              >
                <v-list-item-title>製品明細</v-list-item-title>
              </v-list-item>
              <v-list-item
              dense
              @click="deleteConfirm(item)"
              >
                <v-list-item-title>削除する</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        </v-data-table>
        <confirm-dialog
          ref="confirm"
          title="配送製品削除"
          message="配送製品を削除してもいいですか？"
          buttonMessage="削除"
          @confirm="deleteDeliveryItem"
        >
        </confirm-dialog>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ConfirmDialog from '@/components/ConfirmDialog'

export default {
  components: {
    'confirm-dialog': ConfirmDialog,
  },
  data() {
    return {
      headers: [
        {text: "製品カテゴリ", value: "deliveryitemcategory.name"},
        {text: "製品名", value: "name"},
        {text: "操作", value: "action", width: "130px"},
      ],
      items: [],
      params: {
        deliveryitemcategory: '',
        name: '',
      },
      loading: false,
      item_total: 0,
      options: {
        itemsPerPage: 20,
      },
      footer_props: {
        'items-per-page-options': [],
        'items-per-page-text': null,
        'disable-items-per-page': true,
      },
      deleteItem: {},
    }
  },
  created() {
    this.$store.dispatch('getDeliveryItemCategories');
  },
  methods: {
    async getDeliveryItems() {
      this.loading = true;
      try {
        this.params.page = this.options.page;
        let response = await this.$axios.get(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/`,
          {
            params: this.params,
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.item_total = response.data.count
        this.items = response.data.results
        this.loading = false;
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.loading = false;
      }
    },
    deleteConfirm(item) {
      this.deleteItem = item;
      this.$refs.confirm.open();
    },
    async deleteDeliveryItem() {
      try {
        await this.$axios.delete(
          `${process.env.VUE_APP_API_URL_BASE}/api/products/deliveryitems/${this.deleteItem.id}`,
          {
            headers: {
              Authorization: `JWT ${this.$store.getters.token}`,
            },
          },
        );
        this.$store.dispatch('setSnackbar', {message: "削除されました", type: "success"});
        await this.getDeliveryItems();
      } catch(error) {
        const error_status = error.response.status;
        if (error_status == 401) {
          this.$store.dispatch('userLogout');
        }
        this.$store.dispatch('setSnackbar', {message: "削除できませんでした", type: "error"});
      }
    }
  },
}
</script>